import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "../../../../Application/slices/createFetchingItemsSlice";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import { type BillingTerm } from "../../types/state";
import { type RootState } from "../../../../Application/globaltypes/redux";

export interface PackBillingTermsState extends FetchingItemsState<BillingTerm> {}

const initialState: PackBillingTermsState = {
  items: [],
  itemsCount: 0,
  isLoading: false,
  error: undefined,
};

const packBillingTermsSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.PackBillingTerms,
    name: "packBillingTerms",
  },
  initialState,
  reducers: {},
});

export const { fetchBegin, fetchSuccess, fetchFailure } = packBillingTermsSlice.actions;

export const packBillingTermsSelector = (state: RootState) => state.packs.packBillingTerms.items;

export default packBillingTermsSlice.reducer;
export type packTrialPriodsSliceType = ReturnType<typeof packBillingTermsSlice.reducer>;
